/**
 * @项目名称: landing-page
 * @功能名称: 没有拉到接口时候的默认配置项
 * @文件名称: debug
 * @Date: 2019/4/18
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
export default {
  'landId': '',
  'app': 'cardloan',
  'templateId': 0,
  'templateType': '卡贷通用版',
  'templateName': 'mgm新版(支付注册接口)',
  'templateUrl': 'https://cardloan.xiaoying.com/fe/landing-h5/mgmone/index.html',
  'landName': '',
  'identifyingCode': 0,
  'cardConfig': 1,
  'bgImgUrl': 'https://xcfs-public.xystatic.com/10074/mgm/mgm-one-bg.png',
  'bottomImgUrl': ['https://xcfs-public.xystatic.com/10074/mgm/mgm-one-bottom.png'],
  'buttonCharacters': '立即领取',
  'bottomCharacters': '@2018 深圳市赢众通金融信息服务有限责任公司<br/>客服电话：952592 粤ICP备 14057169号',
  'reportType': 1,
  'toutiaoId': '',
  'toutiaoType': '',
  'doumengReportValue': 0,
  'redirectUrl': '',
  'regSuccRedirect': 'https://cardloan.xiaoying.com/cardloan-h5/kadai/index.html', // 必须的默认配置
  'regSuccType': 2,
  'hasRegType': 1,
  'hasRegRedirect': 'https://cardloan.xiaoying.com/cardloan-h5/kadai/index.html', // 必须的默认配置
  'defCharacters1': '最高可申请15万',
  'defCharacters2': '3分钟极速到账',
  'defCharacters3': '月利率到账0.83%',
  'defCharacters4': '超多还款期可选',
  'templateExtend': [],
  'extend': {
    'title':'小赢卡贷',
    'partnerName':'',
    'warning_text': '借款以实际审批为准，请按需合理借款',
    'warning_color': 'rgb(255, 255, 255, 0.4)',
    'warning_size': '0.6rem',
    'banner_h': '7.5rem',
    'bg_color': '#E34B37',
    'border_radius': '0.3rem',
    'code_color': '#F72A62',
    'but_color': '#FFFFFF',
    'but_bg': '#E34B37',
    'arg_color': '#858A97',
    'bottom_warning': '*请确保所填写的资料准确无误，并属于申请者本人所有<br>*请确保不能从借款中介处借款，借款过程中不会收取额外费用',
    'bottom_warning_color': '#a0a0a0',
    'copy_color': '#a0a0a0',
    'is_baidu': '0',
    'is_kuaishou': '0',
    'productType': 0,
    'contract_type': '',
    'sourceType':'landing-h5',// 项目id注册回传卡贷后台要用
    'regType': 1,
    'simple': '1',
    'existing': '1',
    'isImgReg': '',
    'agreementSelected': '0',
    'ad': '0',
    'is_border': '0',
    'isShowInvite': '0',
    'isGetWXUnionid': '1',
    'wxShareIconUrl': 'https://a1.xystatic.com/page/release/xy-operation-website/stable/0.0.0/kadaidaxia.png',
    'wxShareTitle':'推荐你使用小赢卡贷：高达8万额度，最快3分钟放款！',
    'wxShareContent': '急用钱，快戳我>>'
  },
  'landingChannelList': []
}
